// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum MeasurementUnit {
  Millimeters = 0,
  Centimeters = 1,
  Meters = 2,
  Kilometers = 3,
  Inches = 4,
  Feet = 5,
  Yards = 6,
  Miles = 7
}
